import {
  FETCH_AUCTION_BID,
  FETCH_AUCTION_BID_SUCCESS,
  FETCH_AUCTION_BID_FAILED
} from '../../types';

const initialState = {
  auctionBid: {},
  isLoading: false,
  errors: {},
  error: false
}

const fetchAuctionBidReducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_AUCTION_BID:
      return {
        ...state,
        isLoading: true,
          auctionBid: action.payload
      }
      case FETCH_AUCTION_BID_SUCCESS:
        return {
          ...state,
          isLoading: false,
            auctionBid: action.payload
        }
        case FETCH_AUCTION_BID_FAILED:
          return {
            ...state,
            isLoading: false,
              errors: action.payload,
              error: true
          }
          default:
            return {
              ...state
            };
  }
}

export default fetchAuctionBidReducer;
